import React from 'react'
import { useParams } from 'react-router-dom'
import { Pagination } from 'lib/shared'
import { FadeIn, Spinner, EmptyContainer } from 'lib/ui'
import { useBlogContext } from 'hooks/blog'
import { MainTitle } from '../../components/MainTitle'
import { NoPosts } from '../../components/NoPosts'
import { PostsGrid } from '../../components/PostsGrid'
import { PaginationStyles } from 'components/PaginationStyles'
import { PaginationWrapper } from '../Category/components/Styled'
import { CategoryList } from '../../components/CategoryList'
import { BlogLayout } from '../../components/BlogLayout'
import { Toolbar } from '../../components/Toolbar'
import { MetaData } from 'components/MetaData'

export const Search = () => {
  const { searchQuery } = useParams<{ searchQuery: string }>()
  const { posts, name, postSlugs, loading, pageInfo, handlePageChange } = useBlogContext()

  return (
    <>
      {name && (
        <MetaData
          title={name}
        />
      )}
      <FadeIn
        key={`title-${searchQuery}`}
      >
        <MainTitle
          title={`Results for ${searchQuery}`}
        />
      </FadeIn>

      {!postSlugs || loading ? (
        <EmptyContainer>
          <Spinner />
        </EmptyContainer>
      ) : (
        <BlogLayout>
          <FadeIn
            key={`content-${searchQuery}`}
          >
            {posts?.length ? (
              <PostsGrid
                posts={posts}
              />
            ) : (
              <NoPosts isSearch />
            )}

            <PaginationWrapper>
              <PaginationStyles>
                {pageInfo && (
                  <Pagination
                    currentPage={pageInfo?.currentPage}
                    pageSize={pageInfo?.pageSize}
                    totalItems={pageInfo?.totalItems}
                    onChange={handlePageChange}
                  />
                )}
              </PaginationStyles>
            </PaginationWrapper>
          </FadeIn>
          <div>
            <Toolbar />
            <CategoryList />
          </div>
        </BlogLayout>
      )}
    </>
  )
}
